<template>
  <div>
    <b-modal id="RxTransferListModal" size="xl" title="Rx Transfer Requests" hide-footer>
      <b-table-simple fixed>
        <b-thead head-variant="primary">
          <b-tr>
            <b-th>Entered</b-th>
            <b-th>In/Out</b-th>
            <b-th>Status</b-th>
            <b-th>Drug Name</b-th>
            <b-th>Program Name</b-th>
            <b-th>Reason</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="transfer in unfinishedRxTransfers" :key="`${transfer.id}`" style="cursor: pointer"
                @click="viewTransferDetails(+transfer.id)">
            <b-td> {{ convertDate(transfer.timeStamp) }}</b-td>
            <b-td>{{ transfer.inbound == true ? "Inbound" : "Outbound" }}</b-td>
            <b-td>{{ getRxTransferEnum(transfer.transferStatus) }}</b-td>
            <b-td>{{ transfer.drugName }}</b-td>
            <b-td>{{ transfer.programName }}</b-td>
            <b-td>{{ transfer.rxTransferReasonName }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>

    <b-modal
        id="rxTransferModalEdit"
        hide-footer
        size="lg"
        title="Rx Transfer"
        @hidden="() => patient && getUnfinishedRxTransfers(patient)"
    >
      <RxTransferModalComponent
          :TransferIdDetails="+selectedRxTransfer"
          :patient="patient"
          @complete="$bvModal.hide('rxTransferModalEdit')"
      />
    </b-modal>
  </div>

</template>
<script lang="ts">

import {Component, Vue} from "vue-property-decorator";
import {RxTransfer, transferStatus} from "@/models/RxTransfer";
import Axios from "axios";
import RxTransferModalComponent from "@/components/RxTransfer/RxTransferModalComponent.vue";
import {Patient} from "@/models/Patient";
import moment from 'moment';

@Component({
  name: "RxTransferListModalComponent",
  computed: {},
  components: {RxTransferModalComponent}
})
export default class RxTransferListModalComponent extends Vue {

  private selectedRxTransfer: number | null = null;
  private unfinishedRxTransfers: RxTransfer[] = [];
  private patient: Patient | null = null;

  viewTransferDetails(transferId: number) {
    this.selectedRxTransfer = transferId;
    this.$bvModal.show("rxTransferModalEdit");
  }

  getRxTransferEnum(status: number) {
    return transferStatus[status];
  }

  convertDate(date: string) {
    return moment.utc(date).format("L")
  }

  async getUnfinishedRxTransfers(patient: Patient): Promise<RxTransfer[]> {
    const patientId = patient.id;
    if (!patientId) return [];
    try {
      this.patient = patient;
      const res = await Axios.get(`/RxTransfer/${patientId}/GetUnfinishedByPatient`);
      this.unfinishedRxTransfers = res.data;
      this.$bvModal.hide("rxTransferListModal");
      return res.data;
    } catch (err) {
      console.error('error getting rxtransfers', err);
      return [];
    }
  }

  showModal() {
    this.$bvModal.show("RxTransferListModal");
  }

}

</script>
